const QCVSANDS = [
  {
    HKSCODE: [],
    ID: '0',
    NAME: 'QCV uni almond',
    NCSCODE: 'S1020-G20Y',
    RALCODE: 'D100',
    RGBCODE: '185,206,172',
  },
  {
    HKSCODE: [],
    ID: '1',
    NAME: 'QCV uni apricot',
    NCSCODE: 'S1080-Y20R',
    RALCODE: 'D170',
    RGBCODE: '232,140,0',
  },
  {
    HKSCODE: [],
    ID: '2',
    NAME: 'QCV uni azure blue',
    NCSCODE: 'S2030-B10G',
    RALCODE: 'D112',
    RGBCODE: '96,147,172',
  },
  {
    HKSCODE: 'HKS97',
    ID: '3',
    NAME: 'QCV uni black',
    NCSCODE: [],
    RALCODE: 'D02',
    RGBCODE: '58,65,54',
  },
  {
    HKSCODE: [],
    ID: '4',
    NAME: 'QCV uni brown',
    NCSCODE: [],
    RALCODE: 'D61',
    RGBCODE: '68,47,41',
  },
  {
    HKSCODE: 'HKS 6',
    ID: '5',
    NAME: 'QCV uni brown beige',
    NCSCODE: [],
    RALCODE: 'D04',
    RGBCODE: '255,143,0',
  },
  {
    HKSCODE: [],
    ID: '6',
    NAME: 'QCV uni chestnut',
    NCSCODE: [],
    RALCODE: 'D03',
    RGBCODE: '109,52,45',
  },
  {
    HKSCODE: 'HKS 90',
    ID: '7',
    NAME: 'QCV uni dark grey',
    NCSCODE: [],
    RALCODE: 'D43',
    RGBCODE: '62,53,44',
  },
  {
    HKSCODE: [],
    ID: '8',
    NAME: 'QCV uni fir green',
    NCSCODE: [],
    RALCODE: 'D772',
    RGBCODE: '0,95,78',
  },
  {
    HKSCODE: [],
    ID: '9',
    NAME: 'QCV uni grass green',
    NCSCODE: [],
    RALCODE: 'D371',
    RGBCODE: '108,124,89',
  },
  {
    HKSCODE: [],
    ID: '10',
    NAME: 'QCV uni green',
    NCSCODE: [],
    RALCODE: 'D05',
    RGBCODE: '25,77,37',
  },
  {
    HKSCODE: [],
    ID: '11',
    NAME: 'QCV uni grey white',
    NCSCODE: 'S1002-R',
    RALCODE: 'D01',
    RGBCODE: '225,220,219',
  },
  {
    HKSCODE: [],
    ID: '12',
    NAME: 'QCV uni khaki',
    NCSCODE: [],
    RALCODE: 'D69',
    RGBCODE: '80,83,60',
  },
  {
    HKSCODE: [],
    ID: '13',
    NAME: 'QCV uni lemon',
    NCSCODE: [],
    RALCODE: 'D106',
    RGBCODE: '205,186,136',
  },
  {
    HKSCODE: [],
    ID: '14',
    NAME: 'QCV uni light beige',
    NCSCODE: [],
    RALCODE: 'D60',
    RGBCODE: '210,170,109',
  },
  {
    HKSCODE: [],
    ID: '15',
    NAME: 'QCV uni light green',
    NCSCODE: [],
    RALCODE: 'D729',
    RGBCODE: '138,153,119',
  },
  {
    HKSCODE: 'HKS 6',
    ID: '17',
    NAME: 'QCV uni mandarin',
    NCSCODE: [],
    RALCODE: 'D727',
    RGBCODE: '255,143,0',
  },
  {
    HKSCODE: [],
    ID: '18',
    NAME: 'QCV uni mauve',
    NCSCODE: 'S2010-R40B',
    RALCODE: 'D108',
    RGBCODE: '157,134,146',
  },
  {
    HKSCODE: 'HKS91',
    ID: '19',
    NAME: 'QCV uni mid grey',
    NCSCODE: [],
    RALCODE: 'D74',
    RGBCODE: '173,185,166',
  },
  {
    HKSCODE: [],
    ID: '20',
    NAME: 'QCV uni navy blue',
    NCSCODE: [],
    RALCODE: 'D40',
    RGBCODE: '15,48,82',
  },
  {
    HKSCODE: [],
    ID: '21',
    NAME: 'QCV uni orange',
    NCSCODE: [],
    RALCODE: 'D07',
    RGBCODE: '186,72,27',
  },
  {
    HKSCODE: [],
    ID: '22',
    NAME: 'QCV uni pale grey',
    NCSCODE: 'S4005-R50B',
    RALCODE: 'D113',
    RGBCODE: '149,146,152',
  },
  {
    HKSCODE: [],
    ID: '23',
    NAME: 'QCV uni pink',
    NCSCODE: [],
    RALCODE: 'D115',
    RGBCODE: '216,160,166',
  },
  {
    HKSCODE: 'HKS37',
    ID: '24',
    NAME: 'QCV uni purple',
    NCSCODE: [],
    RALCODE: 'D777',
    RGBCODE: '84,52,120',
  },
  {
    HKSCODE: [],
    ID: '25',
    NAME: 'QCV uni red',
    NCSCODE: [],
    RALCODE: 'D383',
    RGBCODE: '155,36,35',
  },
  {
    HKSCODE: [],
    ID: '26',
    NAME: 'QCV uni sienna',
    NCSCODE: 'S3030-Y80R',
    RALCODE: 'D118',
    RGBCODE: '207,105,85',
  },
  {
    HKSCODE: [],
    ID: '28',
    NAME: 'QCV uni steel blue',
    NCSCODE: 'S4055-R70B',
    RALCODE: 'D768',
    RGBCODE: '34,46,124',
  },
  {
    HKSCODE: [],
    ID: '29',
    NAME: 'QCV uni superwhite',
    NCSCODE: [],
    RALCODE: 'E00',
    RGBCODE: '241,240,234',
  },
  {
    HKSCODE: [],
    ID: '30',
    NAME: 'QCV uni turquoise',
    NCSCODE: [],
    RALCODE: 'D63',
    RGBCODE: '34,95,120',
  },
  {
    HKSCODE: [],
    ID: '31',
    NAME: 'QCV uni ultramarine',
    NCSCODE: [],
    RALCODE: 'D62',
    RGBCODE: '0,83,135',
  },
  {
    HKSCODE: [],
    ID: '32',
    NAME: 'QCV uni white',
    NCSCODE: 'S0502-R50B',
    RALCODE: 'D001',
    RGBCODE: '236,234,237',
  },
  {
    HKSCODE: [],
    ID: '33',
    NAME: 'QCV uni yellow',
    NCSCODE: [],
    RALCODE: 'D06',
    RGBCODE: '221,175,39',
  },
];
export default QCVSANDS;
